/* eslint-disable */
import request from './helpers'

export function listTag (keyword, size, page) {
    return request ({
        url: '/api/v1/tag',
        method: 'get',
        params: {
            keyword, size, page
        }
    })
}

export function createTag (data) {
    return request ({
        url: '/api/v1/tag',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function getTag (id, data) {
    return request ({
        url: '/api/v1/tag/' + id,
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function updateTag (id, data) {
    return request ({
        url: '/api/v1/tag/' + id,
        method: 'put',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function deleteTag (id) {
    return request ({
        url: '/api/v1/tag/' + id,
        method: 'delete'
    })
}

export function getTagDict () {
    return request ({
        url: '/api/v1/tag/dict',
        method: 'get'
    })
}

export function listTagMy () {
    return request ({
        url: '/api/v1/tag/my',
        method: 'get'
    })
}

export function listTagByObjectType (objectType) {
    return request ({
        url: '/api/v1/tag-map/tags/' + objectType,
        method: 'get'
    })
}

export function listUserByIds (data) {
    return request ({
        url: '/api/v1/user/by_ids',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function createTagMap (data) {
    return request ({
        url: '/api/v1/tag-map/batch',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function deleteTagMap (id) {
    return request ({
        url: '/api/v1/tag-map/' + id,
        method: 'delete'
    })
}

export function listTagMap (objectType, ids, page, size) {
    return request ({
        url: '/api/v1/tag-map/list/' + objectType + '/' + ids,
        method: 'get',
        params: {
            page, size
        }
    })
}

export function listTopicByIds (data) {
    return request ({
        url: '/api/v1/topic/by_ids',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function listAgentByIds (data) {
    return request ({
        url: '/api/v1/agent/by_ids',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function listClientInfoMapByIds (data) {
    return request ({
        url: '/api/v1/client_info_map/by_ids',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function listByObjectTypeAndObjectIds (objectType, data) {
    return request ({
        url: '/api/v1/tag-map/list/' + objectType,
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}